import React from 'react';
import { cn } from '../cn';
const GAP = 'var(--table-filter-field-gap, 8px)';
/**
 * One filter cell: optional label + control + hint.
 *
 * Pass `htmlFor` matching the inner `Input`/`Select` `id` for correct a11y label association.
 * CSS variable: `--table-filter-field-gap` (vertical spacing).
 */
export const TableFilterField = ({ className, label, htmlFor, hint, children, }) => (React.createElement("div", { className: cn('min-w-0', className), style: { display: 'grid', gap: GAP } },
    label != null ? (React.createElement("label", { htmlFor: htmlFor, className: "block text-[length:var(--text-body,14px)] font-medium text-[color:var(--form-fg,#0b1220)]" }, label)) : null,
    React.createElement("div", { className: "min-w-0" }, children),
    hint != null ? (React.createElement("p", { className: "text-[length:var(--text-hint,12px)] text-[color:var(--form-fg-muted,rgba(11,18,32,0.66))]" }, hint)) : null));
export default TableFilterField;
